import { createReducer, on } from '@ngrx/store';
import {
  changeDefaultTemplate,
  deleteTemplates,
  getTemplateData,
  getTemplates,
  removeTemplateData,
  saveTemplates,
  sentTemplates,
  setTemplateData,
  setTemplates,
  updateTemplates
} from '../actions/templates.actions';

export interface TemplatesState {
  data: any;
  templateData: any;
  loader: boolean;
}

export const initialState: TemplatesState = {
  data: [],
  templateData: {},
  loader: false
};

export const templatesReducer = createReducer(
  initialState,
  on(getTemplates, (state, { apiConstants }) => {
    return {
      ...state,
      ...apiConstants,
      templateData: {},
      loader: true
    };
  }),
  on(setTemplates, (state, { templatesData }) => {
    return {
      ...state,
      data: [...templatesData],
      sidUserData: {},
      loader: false
    };
  }),
  on(sentTemplates, (state) => {
    return {
      ...state,
      loader: true
    };
  }),
  on(saveTemplates, (state, { templatesData }) => {
    const allData = state.data.length > 0 ? [...state.data, templatesData] : [templatesData];
    return {
      ...state,
      data: allData,
      loader: false
    };
  }),
  on(updateTemplates, (state, { templatesData }) => {
    let allData: any[] = [];
    if (state.data.length > 0) {
      const toBeFilteredData = [...state.data];
      allData = toBeFilteredData.filter((user) => user.sid !== templatesData.sid);
      allData.push(templatesData);
    } else {
      allData = [templatesData];
    }

    return {
      ...state,
      data: allData,
      loader: false
    };
  }),
  on(deleteTemplates, (state, { templatesId }) => {
    return {
      ...state,
      templatesId
    };
  }),
  on(getTemplateData, (state) => {
    return {
      ...state,
      templateData: {},
      loader: true
    };
  }),
  on(setTemplateData, (state, { templateData }) => {
    return {
      ...state,
      templateData,
      loader: false
    };
  }),
  on(removeTemplateData, (state) => {
    return {
      ...state,
      templateData: {},
      loader: false
    };
  }),
  on(changeDefaultTemplate, (state) => {
    return {
      ...state,
      loader: true
    };
  })
);
